<template>
  <section>
    <div :style="{borderColor: $store.getters.clientStyle.primary}"
      class="global-question-card container global-question-card-padding"
      @mouseover="comment.questionIsFocussed=true"
      @mouseleave="() => {if (questionData.comment==1) this.$refs.commentBox.leaveComment()}">
        <question-header />
        <!-- <div class="column question-meta">
          <b-tag class="required-field" rounded type="is-grey">Verplicht</b-tag>
          <b-tag rounded type="is-grey">{{this.number}}</b-tag>
        </div> -->

      <!-- <p class="question-description">{{ questionData.description }}</p> -->

      <div class="columns scale-options">
        <div class="column is-four-fifths">
          <div class="field scale-option" v-for="(value, index) in questionData.values">
            <div v-if="value.status == true">
              <b-radio v-model="questionData.answer"
                  @input="saveAnswer"
                  size="is-medium"
                  type="is-dark"
                  :native-value="value.CROW_QuestionAnswerID">
                  <h3 class="is-size-5 has-text-black-ter scale-option-text">{{ value.text }} {{ value.rating >0 ? '('+value.rating+')':'' }}</h3>
              </b-radio>
            </div>
          </div>
        </div>
        <div class="column question-actions"></div>
      </div>
    </div>
    <comment-box ref="commentBox" v-if="questionData.comment=='1'" />
  </section>
</template>

<script>

import CommentBox from './CommentBox'
import QuestionHeader from './QuestionHeader'

export default {
  data() {
    return {
        radio: 'default',
        answer: null,
        uploads: [],
        comment: {
          showComment: false,
          commentFocussed: false,
          questionIsFocussed: false
        }
    }
  },
  components: {
    'question-header': QuestionHeader,
    'comment-box': CommentBox
  },
  methods: {
    saveAnswer() {
      this.$store.commit('updateActivity', this.$store.getters.getActivities)
      // console.log(JSON.parse(localStorage.getItem('activities')));
    }
  },
  props: {
    questionData: Object,
    number: Number
  },
  provide () {
    return {
      question: this.questionData,
      number: this.number,
      comment: this.comment,
      uploads: this.uploads
    }
  }
}

</script>

<style scoped>

.scale-question {
  margin-top: 100px;
  margin-bottom: 50px;
  /* padding-top: 25px;
  padding-bottom: 20px; */
  padding-left: 40px;
  padding-right: 40px;
  max-width: 980px;
}

.question {

}

.question-description {
  margin-top: 10px;
}

.scale-options {
  padding-top: 42px;
}

.scale-option {
  padding-bottom: 1px;
}

.highlight {
  padding: 5px;
  margin-top: -5px;
  margin-bottom: -5px;
  background-color: #0037661A;
  border-radius: 5px;
}

.scale-option-text {
  padding-left: 10px;
}

.question-actions {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  color: #cccccc;
}

.question-icon {
    margin-left: 20px;
}

.question-meta {
  margin-top: 7px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
}

.question-footer {

}

</style>



// WEBPACK FOOTER //
// src/components/elements/PastPerformanceQuestion.vue